import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { productAssignmentSchema } from '../schemas/product-assignment.schema';
import { userSchema } from '../schemas/user.schema';

const requestSchema = z.array(
  z.object({
    user: userSchema.pick({
      externalId: true,
    }),
    products: z.array(
      productAssignmentSchema.pick({
        productId: true,
        addons: true,
      })
    ),
  })
);

/**
 * Process multiple Product Licenses for a list of Users
 * @param request Array of User External IDs and their product license assignment IDs
 * @returns A Data object containing licenses assigned, licenses not processed, and licenses updated
 */
export function postLicenseBulk(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).licenseUrl}/bulk`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify(request),
      })
    )
  ).pipe(
    selectData(
      z.object({
        errorCode: z.string().nullable(),
        licensesAssigned: z.number(),
        licensesNotProcessed: z.array(z.string()),
        licensesUpdated: z.number(),
        message: z.string().nullable().optional(),
        success: z.boolean().optional(),
      })
    )
  );
}
